export const SET_PROJECT_REQUEST = 'SET_PROJECT_REQUEST';
export const SET_PROJECT_FAILED = 'SET_PROJECT_FAILED';
export const SET_PROJECT_SUCCESS = 'SET_PROJECT_SUCCESS';
export const SET_PROJECT_GUIDE_TIP_SUCCESS = 'SET_PROJECT_GUIDE_TIP_SUCCESS';
export const CLEAN_PROJECT = 'CLEAN_PROJECT';
